import { Injectable } from '@angular/core';
import { ROUTES } from '../services/api/api.constants';
import { ApiService } from '../services/api/api.service';

@Injectable({
  providedIn: 'root'
})

export class OdenpermissionProvider {
  constructor(
    private api: ApiService,
  ) {}

  async index(data) {
    let base = ROUTES.odenPermission.index;
    if(data){
      base += '?filtro='+data.filtro
      if(data.defaults_by_rol)
        base += '&defaults_by_rol='+data.defaults_by_rol
      if(data.available_by_rol)
        base += '&available_by_rol='+data.available_by_rol
    }
    const result = await this.api.get(base);
    return result;
  }
}